module.exports = __webpack_public_path__ + "assets/Omega.fb76124f163d75dca949969c94c5e876.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/packs1x/Omega.png
// module id = 792
// module chunks = 0